/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "tag": {
      "delete": "Delete"
    }
  },
  "de-DE": {
    "tag": {
      "delete": "Löschen"
    }
  },
  "es-ES": {
    "tag": {
      "delete": "Eliminar"
    }
  },
  "fr-FR": {
    "tag": {
      "delete": "Supprimer"
    }
  },
  "it-IT": {
    "tag": {
      "delete": "Elimina"
    }
  },
  "jp-JP": {
    "tag": {
      "delete": "削除"
    }
  },
  "ko-KO": {
    "tag": {
      "delete": "삭제"
    }
  },
  "pt-PT": {
    "tag": {
      "delete": "Excluir"
    }
  },
  "ru-RU": {
    "tag": {
      "delete": "Удалить"
    }
  },
  "vi-VN": {
    "tag": {
      "delete": "Xóa"
    }
  },
  "zh-CN": {
    "tag": {
      "delete": "删除"
    }
  },
  "zh-TW": {
    "tag": {
      "delete": "刪除"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
